import { createSlice } from '@reduxjs/toolkit'

interface ProjectUses {
    acquisition: number,
    constructionCost: number,
    developmentCost:number,
    financeCost: number,
    softCost: number
}

const initialState:ProjectUses = {
    acquisition: 0,
    constructionCost: 0,
    developmentCost:0,
    financeCost: 0,
    softCost: 0
}

const ProjectUsesSlice = createSlice({
    name: "projectUses",
    initialState,
    reducers: {
        set(state, {payload}){
            return{
                ...state,
                ...payload
            }
        }
    
    }
});

export const {
set
} = ProjectUsesSlice.actions
export default ProjectUsesSlice.reducer